import { ReactNode } from 'react';

import {
  ChakraFlex,
  ChakraText,
  ChakraToolTip,
  EquipUITheme,
} from '@equip.health/ui';

interface IconTextProps {
  content: string[];
  contentColor?: string;
  icon: ReactNode;
  isContentBold?: boolean;
  isTruncated?: boolean;
  showToolTip?: boolean;
  tooltipContent?: string[];
}

const IconText = ({
  content,
  contentColor,
  icon,
  isContentBold = false,
  isTruncated,
  showToolTip,
  tooltipContent,
}: IconTextProps) => {
  const { label, labelBold } = EquipUITheme.typography;

  const getGenderDetails = (
    isTruncated: boolean,
    showToolTip: boolean,
    textVal: string,
    tooltipVal: string,
  ) => {
    const body = (
      <ChakraText
        {...(isContentBold ? { ...labelBold } : { ...label })}
        color="neutral.secondary"
        key={textVal}
        marginLeft="8px"
        maxWidth={isTruncated ? '250px' : undefined}
        overflow={isTruncated ? 'hidden' : undefined}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {textVal}
      </ChakraText>
    );
    return !showToolTip ? (
      body
    ) : (
      <ChakraToolTip
        bg="white"
        color="neutral.secondary"
        gutter={3}
        hasArrow
        id={`${textVal}__tooltip`}
        label={tooltipVal || textVal}
      >
        {body}
      </ChakraToolTip>
    );
  };

  return (
    <ChakraFlex alignItems="center">
      {icon}
      <ChakraFlex flexDirection="column" width="100%">
        {content?.map((textVal, index) =>
          !isTruncated && !showToolTip ? (
            <ChakraText
              {...(isContentBold ? { ...labelBold } : { ...label })}
              color={contentColor || 'neutral.secondary'}
              key={textVal}
              marginLeft="8px"
            >
              {textVal}
            </ChakraText>
          ) : (
            getGenderDetails(
              isTruncated,
              showToolTip,
              textVal,
              tooltipContent?.length > 0 ? tooltipContent[index] : textVal,
            )
          ),
        )}
      </ChakraFlex>
    </ChakraFlex>
  );
};
export default IconText;
